import { BrowserModule } from '@angular/platform-browser';
import { Injector, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
// import { FormioModule } from '@formio/angular';
import { AngularFileUploaderModule } from "angular-file-uploader";
import { FileUploadComponent } from './file-upload/file-upload.component';
import { EastCoast2Component } from './east-coast-2/east-coast-2.component';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { AudaThankyouComponent } from './auda-thankyou/auda-thankyou.component';
import { EastCoastThankyouComponent } from './east-coast-thankyou/east-coast-thankyou.component';
import { ArbExpComponent } from './arb-exp/arb-exp.compnent';
import { AudaComponent } from './auda/auda.component';
import { NtApplicationComponent } from './nt-application/nt-application.component';
import { WAApplicationComponent } from './wa-application/wa-application.component';
import { MyNewComponent } from './newComp/newComp.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormioModule } from 'angular-formio';
import { FileUploadFormioComponent } from './fileUpload/fileUpload-formio.component';
import { registerFileUploadFormioComponent } from './fileUpload/FileUploadFormio.formio';
import { EastCoastApplication } from './east-coast/east-coast.component';
import { AppService } from './app.service';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { WaThankyouComponent } from './wa-thankyou/wa-thankyou.component';


@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    EastCoast2Component,
    CounterComponent,
    FetchDataComponent,
    FileUploadComponent,
    ArbExpComponent,
    AudaComponent,
    NtApplicationComponent,
    WAApplicationComponent,
    MyNewComponent,
    FileUploadFormioComponent,
    ThankyouComponent,
    AudaThankyouComponent,
    WaThankyouComponent,
    EastCoastApplication,
    EastCoastThankyouComponent
  ],
  imports: [
    NgxUiLoaderModule,
    BrowserModule,
    // BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    CommonModule,
    FormioModule,
    NgbModule,
    HttpClientModule,
    AngularFileUploaderModule,
    FormsModule,
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'counter', component: CounterComponent, pathMatch: 'prefix' },
      { path: 'fetch-data', component: FetchDataComponent, pathMatch: 'prefix' },
      { path: 'file-upload', component: FileUploadComponent, pathMatch: 'prefix' },
      { path: 'east-coast-2', component: EastCoast2Component, pathMatch: 'prefix' },
      { path: 'thankyou', component: ThankyouComponent, pathMatch: 'prefix' },
      { path: 'auda-thankyou', component: AudaThankyouComponent, pathMatch: 'prefix' },
      { path: 'wa-thankyou', component: WaThankyouComponent, pathMatch: 'prefix' },
      { path: 'east-coast-thankyou', component: EastCoastThankyouComponent, pathMatch: 'prefix' },
      { path: 'arb-expense', component: ArbExpComponent, pathMatch: 'prefix' },
      { path: 'auda', component: AudaComponent, pathMatch: 'prefix' },
      { path: 'nt-application', component: NtApplicationComponent, pathMatch: 'prefix' },
      { path: 'wa-application', component: WAApplicationComponent, pathMatch: 'prefix' },
      { path: 'east-coast', component: EastCoastApplication, pathMatch: 'prefix' },
      // { path: 'east-coast', component: EastCoastApplication }
    ])
  ],
  providers: [
    AppService
  ],
  entryComponents: [FileUploadFormioComponent],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(injector: Injector) {
    registerFileUploadFormioComponent(injector);
  }
}
